import * as React from 'react'
import { NameType, Payload, ValueType } from 'recharts/types/component/DefaultTooltipContent'

import { shortFormatNumber } from '../../util'
import { TooltipInner, TooltipRow } from '../chart/Tooltip'
import { ChartItemColorType } from '../chart/constants'
import { LineChartTooltipSort } from './types'

type ChartTooltipProps = {
  activeKey?: string | null
  payload?: Payload<ValueType, NameType>[] | undefined
  isReversed?: boolean
  payloadSort?: keyof typeof LineChartTooltipSort
  valueFormatter?: (data: ValueType) => string
}
export default function ChartTooltip({
  payload,
  payloadSort = 'default',
  isReversed = false,
  valueFormatter,
}: ChartTooltipProps) {
  const items = React.useMemo(() => {
    if (!payload || payload.length === 0) return []

    if (LineChartTooltipSort[payloadSort] === LineChartTooltipSort.value) {
      return [...payload].sort((a, b) => Number(b.value ?? 0) - Number(a.value ?? 0))
    }
    return isReversed ? [...payload].reverse() : payload
  }, [payload, payloadSort, isReversed])

  const formatter = React.useCallback(
    (value: ValueType) => valueFormatter?.(value) ?? shortFormatNumber(value as number),
    [valueFormatter]
  )

  if (items.length === 0) return null

  return (
    <TooltipInner payload={payload} formatValue={formatter}>
      {items.map((area) => (
        <TooltipRow
          key={area.dataKey}
          label={area.name}
          dataKey={area.dataKey as string}
          indicator={area.color as ChartItemColorType}
          labelClass="min-w-56"
          valueClass="w-14"
        />
      ))}
    </TooltipInner>
  )
}
